module.exports = __webpack_public_path__ + "static/cover.ee5724d9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeSection/videos/cover.mp4
// module id = 396
// module chunks = 221374088121123